import * as yup from 'yup';
import { nullableStringYup } from '@/utils';

export const entityNoteFormValidationSchema = yup.object().shape({
  note: nullableStringYup().required().max(500),
});
